import type Model from '@ember-data/model';
import { camelize } from '@ember/string';
import type { RhsRecord } from 'uplisting-frontend/utils/rhs/types';

export function getRhsRecordKey(record: RhsRecord): string {
  return camelize((record.constructor as typeof Model).modelName as string);
}

export function getParentRouteRecordKey(
  route: string,
): 'booking' | 'bookingRequest' | 'enquiry' {
  if (route.includes('booking-requests')) {
    return 'bookingRequest';
  } else if (route.includes('bookings')) {
    return 'booking';
  } else if (route.includes('enquiries')) {
    return 'enquiry';
  }

  throw new Error(`Unsupported route: ${route}`);
}
